var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNhlLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_588406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95596 27.3715C4.95596 23.3571 6.83906 21.8305 7.22466 18.0273C6.69644 21.3604 4.48584 24.0913 4.48584 27.3715C4.48584 28.6314 4.66015 29.7829 4.97444 30.8261C6.36366 35.4427 10.4917 38.0125 14.4903 39.0241C8.33128 37.4658 4.95596 32.2972 4.95596 27.3715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9811 22.1049C38.2337 20.2878 37.4123 18.6477 37.4123 16.6299C37.4123 21.5159 39.7497 22.8972 39.7497 27.3686C39.7497 32.2942 36.3744 37.4629 30.2153 39.0211C35.7696 37.616 40.1855 33.5488 40.1855 27.3686C40.1855 25.2742 39.6071 23.6288 38.9811 22.1049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1482 7.90091C36.8884 7.52852 35.9693 6.57772 35.42 5.0723L34.1443 1.57812L33.5527 3.78872C34.7624 9.21882 39.2311 9.6097 39.2311 9.6097L41.0455 8.75663L38.1509 7.90355L38.1482 7.90091Z",
    fill: "#D0D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0649 27.6778L14.7275 24.0965L12.1313 26.0456C12.1313 26.0456 13.0399 26.072 13.0399 27.0228V33.7682L14.8728 32.3922V27.625L16.9619 30.8234L18.8978 29.3708V20.9668L17.0649 22.3428V27.6805V27.6778Z",
    fill: "#D0D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4939 19.865L22.4259 21.418V18.312L19.6343 20.4091C19.6343 20.4091 20.5428 20.4355 20.5428 21.3889V28.1316L22.4259 26.7186V23.6444L24.4939 22.0914V25.1657L26.2872 23.8187V15.4121L24.4939 16.7591V19.865Z",
    fill: "#D0D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.734 19.0856V12.8262L26.9424 14.9232C26.9424 14.9232 27.8509 14.9496 27.8509 15.9004V22.6458L33.0486 18.7422C32.9377 17.3979 33.0486 16.5977 33.0486 16.5977L29.734 19.0856Z",
    fill: "#D0D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98308 16.6399C5.98308 21.4124 3.64307 22.3606 3.64307 27.3681C3.64307 28.8946 3.90189 30.3235 4.36937 31.6387C4.51463 31.3376 4.7312 31.0471 4.97682 30.8226C4.66253 29.7794 4.48822 28.6279 4.48822 27.3681C4.48822 24.0878 6.69617 21.3569 7.22704 18.0239C7.26929 17.5907 7.2957 17.1285 7.2957 16.6294C7.2957 12.8209 5.47863 9.60405 5.47863 9.60405L3.6642 8.75098L4.89495 11.5453C5.5156 12.953 5.98572 14.6829 5.98572 16.6373L5.98308 16.6399Z",
    fill: "url(#paint0_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4121 16.6326C37.4121 18.6504 38.2335 20.2905 38.9809 22.1076L39.9581 22.0759C39.3533 20.5599 38.7247 19.1152 38.7247 16.6432C38.7247 14.6887 39.1949 12.9588 39.8155 11.5511L41.0463 8.75684L39.2318 9.60991C39.2318 9.60991 37.4148 12.8268 37.4148 16.6352L37.4121 16.6326Z",
    fill: "url(#paint1_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9233 40.4873C19.4363 39.9512 17.4159 39.7636 14.4895 39.0241C10.4909 38.01 6.36288 35.4428 4.97366 30.8262C4.72804 31.0507 4.51147 31.3412 4.36621 31.6423C5.94295 36.0952 9.89139 39.2196 14.162 40.3183C16.8929 41.0076 18.1659 41.0763 20.2049 41.6467C20.4716 41.9267 22.3521 43.9604 22.3521 43.9604V42.0112C22.3521 42.0112 21.1134 40.6695 20.9233 40.49V40.4873Z",
    fill: "url(#paint2_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8176 37.7293C18.0741 38.556 20.2054 38.6511 21.6343 39.3404C21.6343 39.3404 22.1546 39.8158 22.35 40.035C22.5481 39.8158 23.0684 39.3404 23.0684 39.3404C24.4972 38.6511 26.6286 38.556 29.885 37.7293C33.9972 36.6861 38.4316 33.0625 38.4316 27.3683C38.4316 23.2957 36.0943 21.8009 36.0943 16.6296C36.0943 13.1434 37.4122 10.4574 37.4122 10.4574C37.4122 10.4574 34.3723 9.84199 32.9566 5.99391C32.9566 5.99391 30.9388 7.87701 28.1551 7.87701C24.6662 7.87701 22.35 5.42871 22.35 5.42871C22.35 5.42871 20.0338 7.87701 16.5475 7.87701C13.7638 7.87701 11.746 5.99391 11.746 5.99391C10.3304 9.84199 7.29046 10.4574 7.29046 10.4574C7.29046 10.4574 8.60837 13.1434 8.60837 16.6296C8.60837 21.8009 6.271 23.2957 6.271 27.3683C6.271 33.0625 10.708 36.6861 14.8202 37.7293H14.8176ZM36.9421 27.3683C36.9421 32.1989 33.094 35.3735 29.5179 36.282C26.9376 36.9396 23.7815 37.2777 22.828 37.8191C22.6141 37.9776 22.35 38.2549 22.35 38.2549C22.35 38.2549 22.0885 37.975 21.872 37.8191C20.9185 37.2777 17.7624 36.9396 15.1821 36.282C15.0843 36.2582 14.9866 36.2318 14.8889 36.2028L35.1884 20.9584C35.8803 23.3776 36.9368 24.9623 36.9368 27.3683H36.9421ZM35.4974 11.2735C35.0854 12.5095 34.6047 14.419 34.6047 16.6296C34.6047 17.5461 34.6707 18.3595 34.7843 19.0938L13.0032 35.4501C10.2749 34.0476 7.88471 31.3564 7.76586 27.6588L32.7982 8.86478C33.6724 10.077 34.6734 10.8245 35.4947 11.2761L35.4974 11.2735ZM10.1006 16.6322C10.1006 14.4216 9.61991 12.5095 9.2079 11.2761C10.1666 10.7505 11.3736 9.81822 12.3323 8.21507C13.365 8.79347 14.8282 9.37451 16.5475 9.37451C19.1516 9.37451 21.1879 8.2362 22.35 7.38312C23.5147 8.23884 25.5484 9.37451 28.1551 9.37451C28.5698 9.37451 28.9712 9.34018 29.3542 9.27943L8.02997 25.2924C8.64534 22.8837 10.0979 20.8871 10.0979 16.6296L10.1006 16.6322Z",
    fill: "url(#paint3_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5501 6.54574C20.0495 6.54574 22.3526 3.56922 22.3526 3.56922V1.70725L20.5196 3.51904C19.5768 4.45135 18.0713 5.21199 16.5474 5.21199C15.4118 5.21199 14.3395 4.7049 13.4045 3.93105L10.5601 1.5752L11.1517 3.78579C11.1517 3.78579 13.8297 6.54574 16.5474 6.54574H16.5501Z",
    fill: "url(#paint4_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1852 27.3713C40.1852 33.5515 35.7693 37.6187 30.2151 39.0238C27.2888 39.7633 25.2683 39.9535 23.7814 40.487C23.5912 40.6666 22.3525 42.0082 22.3525 42.0082V43.9574C22.3525 43.9574 24.2356 41.9237 24.4998 41.6438C26.536 41.0759 27.809 41.0073 30.5426 40.3153C36.0704 38.8918 41.0621 34.0744 41.0621 27.3686C41.0621 24.9547 40.518 23.4836 39.9555 22.0732L38.9783 22.1049C39.6068 23.6288 40.1826 25.2743 40.1826 27.3686L40.1852 27.3713Z",
    fill: "url(#paint5_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1574 6.54574C30.8724 6.54574 33.5505 3.78579 33.5505 3.78579L34.1421 1.5752L31.2976 3.93105C30.3601 4.70754 29.2904 5.21199 28.1547 5.21199C26.6308 5.21199 25.1254 4.45135 24.1825 3.51904L22.3496 1.70725V3.56922C22.3496 3.56922 24.6526 6.54574 28.1547 6.54574H28.1574Z",
    fill: "url(#paint6_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1542 3.78579L10.5626 1.5752L9.28696 5.06937C8.73761 6.57479 7.81851 7.52823 6.55871 7.89798L3.66406 8.75106L5.4785 9.60413C5.4785 9.60413 9.94459 9.21325 11.1569 3.78315L11.1542 3.78579Z",
    fill: "url(#paint7_linear_470_588406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40459 16.6402C5.40459 21.2304 3.06458 22.2736 3.06458 27.3683C3.06458 34.7105 8.74294 39.5147 14.0172 40.8722C16.6821 41.5219 17.4876 41.5642 19.8963 42.1584C20.0944 42.3697 22.3525 44.8022 22.3525 44.8022C22.3525 44.8022 24.6107 42.3697 24.8087 42.1584C27.2148 41.5668 28.0203 41.5219 30.6878 40.8722C35.9621 39.5147 41.6405 34.7105 41.6405 27.3683C41.6405 22.2736 39.3004 21.2277 39.3004 16.6402C39.3004 14.9842 39.6517 13.3467 40.341 11.7805L41.8359 8.38672L38.31 7.34877C37.2351 7.03184 36.4454 6.19725 35.9621 4.87406L34.4038 0.611328L30.9308 3.48748C30.0091 4.25076 29.0768 4.63636 28.1576 4.63636C26.9269 4.63636 25.5271 4.03947 24.5922 3.11245L22.3552 0.899208L20.1181 3.11245C19.1832 4.03947 17.7808 4.63636 16.5527 4.63636C15.6309 4.63636 14.6986 4.25076 13.7769 3.48748L10.2985 0.611328L8.7403 4.87406C8.25698 6.19725 7.46729 7.0292 6.38972 7.34877L2.86914 8.38672L4.364 11.7805C5.05333 13.3467 5.40459 14.9842 5.40459 16.6402ZM6.55611 7.89812C7.81592 7.52572 8.73238 6.57493 9.28437 5.0695L10.56 1.57533L13.4045 3.93119C14.3394 4.70767 15.4091 5.21212 16.5474 5.21212C18.0687 5.21212 19.5767 4.45148 20.5196 3.51918L22.3525 1.70738L24.1854 3.51918C25.1283 4.45148 26.6337 5.21212 28.1576 5.21212C29.2933 5.21212 30.363 4.70503 31.3006 3.93119L34.145 1.57533L35.4207 5.0695C35.97 6.57493 36.8891 7.52836 38.1489 7.89812L41.0436 8.75119L39.8128 11.5455C39.1922 12.9532 38.722 14.6831 38.722 16.6375C38.722 19.1096 39.3506 20.5569 39.9554 22.0702C40.518 23.4806 41.0621 24.9517 41.0621 27.3656C41.0621 34.0714 36.0677 38.8888 30.5426 40.3123C27.809 41.0016 26.536 41.0703 24.4997 41.6408C24.233 41.9207 22.3525 43.9544 22.3525 43.9544C22.3525 43.9544 20.4694 41.9207 20.2053 41.6408C18.169 41.0729 16.896 41.0043 14.1625 40.3123C9.89182 39.2136 5.94338 36.0918 4.36664 31.6363C3.89917 30.321 3.64034 28.8922 3.64034 27.3656C3.64034 22.3581 5.98035 21.41 5.98035 16.6375C5.98035 14.6831 5.51024 12.9532 4.88958 11.5455L3.65883 8.75119L6.55347 7.89812H6.55611Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8936 36.2024C14.9913 36.2315 15.089 36.2579 15.1867 36.2817C17.7671 36.9393 20.9205 37.2774 21.8766 37.8188C22.0905 37.9772 22.3547 38.2546 22.3547 38.2546C22.3547 38.2546 22.6161 37.9746 22.8327 37.8188C23.7861 37.2774 26.9422 36.9393 29.5226 36.2817C33.0986 35.3731 36.9467 32.1985 36.9467 27.368C36.9467 24.9619 35.8903 23.3773 35.1983 20.958L14.8988 36.2024H14.8936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02979 25.2921L29.354 9.27912C28.971 9.33987 28.5696 9.3742 28.1549 9.3742C25.5482 9.3742 23.5145 8.23589 22.3498 7.38281C21.1851 8.23853 19.1514 9.3742 16.5473 9.3742C14.828 9.3742 13.3648 8.79316 12.3321 8.21476C11.3708 9.81791 10.1664 10.7502 9.20771 11.2758C9.61973 12.5118 10.1004 14.4213 10.1004 16.6319C10.1004 20.8894 8.64516 22.8834 8.03243 25.2947L8.02979 25.2921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0059 35.4532L34.787 19.0968C34.6734 18.3626 34.6074 17.5492 34.6074 16.6327C34.6074 14.4221 35.0854 12.5099 35.5001 11.2766C34.6761 10.8249 33.6751 10.0775 32.8035 8.86523L7.76855 27.6619C7.8874 31.3595 10.275 34.0507 13.0059 35.4532ZM29.7346 12.8269V19.0863L33.0491 16.5984C33.0491 16.5984 32.9382 17.3986 33.0491 18.7429L27.8515 22.6465V15.9011C27.8515 14.9477 26.9429 14.9239 26.9429 14.9239L29.7346 12.8269ZM22.4293 18.3124V21.4184L24.4973 19.8654V16.7595L26.2906 15.4125V23.8191L24.4973 25.1661V22.0919L22.4293 23.6448V26.7191L20.5462 28.132V21.3893C20.5462 20.4359 19.6376 20.4095 19.6376 20.4095L22.4293 18.3124ZM14.7278 24.0964L17.0652 27.6778V22.3401L18.8981 20.9641V29.3681L16.9622 30.8207L14.8731 27.6223V32.3895L13.0402 33.7655V27.0201C13.0402 26.0667 12.1316 26.0429 12.1316 26.0429L14.7278 24.0938V24.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22427 18.0267C6.83867 21.8299 4.95557 23.3564 4.95557 27.3709C4.95557 32.2966 8.33089 37.4652 14.4899 39.0234C17.4163 39.7629 19.4367 39.9531 20.9236 40.4866C21.1138 40.6662 22.3525 42.0079 22.3525 42.0079C22.3525 42.0079 23.5885 40.6662 23.7813 40.4866C25.2682 39.9505 27.2887 39.7629 30.215 39.0234C36.3741 37.4652 39.7494 32.2966 39.7494 27.3709C39.7494 22.8995 37.412 21.5182 37.412 16.6322C37.412 12.8237 39.2291 9.60689 39.2291 9.60689C39.2291 9.60689 34.763 9.216 33.5507 3.78591C33.5507 3.78591 30.8727 6.54585 28.1576 6.54585C24.6582 6.54585 22.3525 3.56934 22.3525 3.56934C22.3525 3.56934 20.0494 6.54585 16.55 6.54585C13.8323 6.54585 11.1542 3.78591 11.1542 3.78591C9.9446 9.216 5.47586 9.60689 5.47586 9.60689C5.47586 9.60689 7.29294 12.8237 7.29294 16.6322C7.29294 17.1314 7.26653 17.5936 7.22427 18.0267ZM7.2903 10.46C7.2903 10.46 10.3302 9.84458 11.7458 5.9965C11.7458 5.9965 13.7636 7.87961 16.5473 7.87961C20.0336 7.87961 22.3498 5.43131 22.3498 5.43131C22.3498 5.43131 24.6661 7.87961 28.155 7.87961C30.9387 7.87961 32.9565 5.9965 32.9565 5.9965C34.3721 9.84458 37.412 10.46 37.412 10.46C37.412 10.46 36.0941 13.146 36.0941 16.6322C36.0941 21.8035 38.4315 23.2983 38.4315 27.3709C38.4315 33.0651 33.9971 36.6887 29.8849 37.7319C26.6284 38.5586 24.497 38.6537 23.0682 39.343C23.0682 39.343 22.5479 39.8184 22.3498 40.0376C22.1544 39.8184 21.6341 39.343 21.6341 39.343C20.2026 38.6537 18.0739 38.5586 14.8174 37.7319C10.7052 36.6887 6.26819 33.0651 6.26819 27.3709C6.26819 23.2983 8.60556 21.8035 8.60556 16.6322C8.60556 13.146 7.28766 10.46 7.28766 10.46H7.2903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4404 40.5132C36.4404 41.3452 37.1166 42.0187 37.9485 42.0187C38.7804 42.0187 39.4539 41.3425 39.4539 40.5132C39.4539 39.6839 38.7804 39.0078 37.9485 39.0078C37.1166 39.0078 36.4404 39.6813 36.4404 40.5132ZM39.1291 40.5132C39.1291 41.1682 38.6008 41.6964 37.9459 41.6964C37.2909 41.6964 36.7626 41.1682 36.7626 40.5132C36.7626 39.8582 37.2909 39.33 37.9459 39.33C38.6008 39.33 39.1291 39.8582 39.1291 40.5132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3273 41.3717H37.6496V40.6744H37.882L38.2068 41.3717H38.5634L38.2227 40.6428C38.4208 40.5714 38.5634 40.3839 38.5634 40.1621C38.5634 39.8795 38.3336 39.6523 38.051 39.6523H37.3247V41.3717H37.3273ZM37.6496 39.9746H38.0536C38.1567 39.9746 38.2412 40.0591 38.2412 40.1621C38.2412 40.2651 38.1567 40.3496 38.0536 40.3496H37.6496V39.9746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_470_588406",
    x1: 19.4543,
    y1: 33.7169,
    x2: 24.2211,
    y2: 33.7169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C4CACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#909AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_470_588406",
    x1: 39.2265,
    y1: 22.1049,
    x2: 39.2265,
    y2: 8.75419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#7C888F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_470_588406",
    x1: 4.36621,
    y1: 37.3919,
    x2: 22.3521,
    y2: 37.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_470_588406",
    x1: 33.0227,
    y1: 36.4827,
    x2: 11.7011,
    y2: 6.03088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C888F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#859097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AEB5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C7CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C9CCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B3B9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#90999F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_470_588406",
    x1: 10.5601,
    y1: 4.06047,
    x2: 22.3526,
    y2: 4.06047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_470_588406",
    x1: 22.3525,
    y1: 33.0153,
    x2: 41.0621,
    y2: 33.0153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D6DADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B7BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8F9A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_470_588406",
    x1: 22.3523,
    y1: 4.06047,
    x2: 34.1448,
    y2: 4.06047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_470_588406",
    x1: 3.66142,
    y1: 5.5923,
    x2: 11.1542,
    y2: 5.5923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EAECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D1D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AEB5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#828D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7C888F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_588406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.9668,
    height: 44.1908,
    fill: "white",
    transform: "translate(2.86914 0.611328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhlLeague);
export default __webpack_public_path__ + "static/media/nhl-league.7ce9d17359aaa15d512e602689647743.svg";
export { ForwardRef as ReactComponent };